import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import imgStep1 from '../assets/img-step-1.png'
import imgColor1 from '../assets/img-corte-1.png'
import imgBodaPreviw from '../assets/boda-img.webp'
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp'
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'

const Step2 = ({ nextStep, prevStep, handleInputChange, formData }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.ringStyle || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1, 
      text: "D",
      value1: 3600,
      value2: 9000,
      value3: 10125,
      value4: 33750,
      title: "Color D",
      description: "Grado más alto, absolutamente «incoloro», apreciado mejor engastado en platino u oro blanco. Excepcionalmente raro.",
      image: imgStep1,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "E", 
      value1: 2250,
      value2: 6750,
      value3: 7425,
      value4: 20250,
      title: "Color E",
      description: "Un grado «incoloro» apreciado mejor engastado en platino u oro blanco. Las trazas de color son difíciles de detectar incluso para un ojo entrenado.",
      image: imgColor1
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "F",
      value1: 1125,
      value2: 4500,
      value3: 4950,
      value4: 11250,
      title: "Color F",
      description: "Un grado «incoloro» apreciado mejor engastado en platino u oro blanco. Color débil detectable por un gemólogo experto.",
      image: imgStep1
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "G",
      value1: 675,
      value2: 2250,
      value3: 2475,
      value4: 7875,
      title: "Color G",
      description: "El grado «casi incoloro» más alto. El color puede ser detectable en comparación con grados «incoloros» mucho más altos. Excelente relación calidad-precio.",
      image: imgColor1
    },
    {
      id: 5,
      icon: iconRadio1,
      text: "H",
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      title: "Color H",
      description: "Grado «casi incoloro» CA, el color sólo es perceptible cuando se compara con grados de color muy superiores. Valor excelente.",
      image: imgStep1
    }
  ];

  const handleOptionSelect = (option) => {
    const selectedCaratId = formData?.carats?.selectedId;
    const valueKey = `value${selectedCaratId}`;
    const finalValue = selectedCaratId ? option[valueKey] : option.value1;

    setSelectedOption(option);
    handleInputChange('ringColor', {
      ...option,
      value: finalValue
    });
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
          <h2 className='heading-style-h3 text-align-center'>Escoge el Color que más te inspire para el diamante</h2>
          <p className='text-size-medium text-color-grey'>Al ser una característica sumamente importante y visible, pues influye en cómo se refleja la luz en el diamante, en Tressor recomendamos  diamantes con color de la D a la H. </p>
          <div className="radio-options">
            {options.map((option) => (
              <label key={option.id} className="radio-label">
                <input
                  type="radio"
                  name="ringStyle"
                  checked={selectedOption?.id === option.id}
                  onChange={() => handleOptionSelect(option)}
                />
                <img src={option.icon} className="radio-icon" alt="ring icon" />
                <span className="radio-text">{option.text}</span>
              </label>
            ))}
          </div>

          </div>
          
          <div className="wrapp-btns">
        <button className="button-prev" onClick={prevStep}>
          <img src={iconArrowLeft} alt="arrow left" />
          Volver
        </button>
        <button 
          className="button" 
          onClick={nextStep}
          disabled={!selectedOption}
        >
          Siguiente
          <img src={iconArrowRight} alt="arrow right" />
        </button>
      </div>
        </div>
        
        <div className="preview-column">
          
          {selectedOption ? (
            <>
            <div className='imgOptionSelected'>
            <img 
                src={selectedOption.image} 
                alt={selectedOption.text}
                className="ring-preview-image"
              />

            </div>
            <div className='textOptionSelected'>
            <h3 className="text-align-left">{selectedOption.title}</h3>
              <p className="text-style-medium text-align-left">
                {selectedOption.description}
              </p>
            </div>
              
              
            </>
          ) : (
            <div className="no-selection-message">
              
              <img src={imgAnilloBodasPrev} className='imgPreviewNoText'/>
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Color</p>
                <p className='text-size-large text-color-white'>Por favor selecciona color</p>
              </div>
              

            </div>
          )}
        </div>
      </div>

      
    </div>
  );
};

export default Step2;
